import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../features/auth/authSlice";
import { useTranslation } from "../../../utils/translation";
import { collection, query, where, getDocs, Timestamp } from "firebase/firestore";
import { db } from "../../../config/firebase";

const Header = ({ onNote }) => {
  const { t } = useTranslation();
  const [hasImmediateActivity, setHasImmediateActivity] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onLogout = async () => {
    await dispatch(logout());
    navigate("/login");
  };

  useEffect(() => {
    const fetchImmediateActivities = async () => {
      if (!user) return;
      const now = new Date();
      const in30Min = new Date(now.getTime() + 30 * 60000);
      const q = query(
        collection(db, "meetings"),
        where("startDate", ">=", Timestamp.fromDate(now)),
        where("startDate", "<=", Timestamp.fromDate(in30Min))
      );
      const snapshot = await getDocs(q);
      const results = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter(
          (activity) =>
            activity.users?.includes(user.uid) || activity.adminUsers?.includes(user.uid)
        );
      setHasImmediateActivity(results.length > 0);
    };
    fetchImmediateActivities();
    const interval = setInterval(fetchImmediateActivities, 60 * 1000);
    return () => clearInterval(interval);
  }, [user]);

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <Link onClick={() => navigate(-1)} className="nav-item me-3">
                <i className="fa fa-arrow-left me-3" aria-hidden="true"></i>
              </Link>
            </div>

            <ul className="navbar-nav header-right main-notification align-items-center">

              <Link to="/MyBusiness" className="nav-item me-3">
                <i className="fa fa-building me-3" aria-hidden="true"></i>
                <span className="ms-2">{t("business")}</span>
              </Link>
              <Link to="/MyProfile" className="nav-item me-3">
                <i className="fa fa-user me-3" aria-hidden="true"></i>
                <span className="ms-2">{t("profile")}</span>
              </Link>

              <Link className="nav-item me-3" onClick={onLogout}>
                <i className="fa fa-power-off me-3" aria-hidden="true"></i>
                <span className="ms-2">{t("logout")}</span>
              </Link>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
